import "./styles.css";
import { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Divider,
  Paper,
  Grid,
  IconButton,
  Snackbar,
  Alert,
  Select,
  MenuItem,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import {
  ConstructionOutlined as ImprovementsIcon,
  FavoriteBorderOutlined as ComplimentIcon,
  EmojiObjectsOutlined as IdeasIcon,
  ErrorOutline as ErrorOutlineIcon,
  Wifi as WifiIcon,
  Send as SendIcon,
  Visibility,
  VisibilityOff,
  Login,
  AccountCircleOutlined,
} from "@mui/icons-material";
import TeleinBanner from "../../assets/images/telein-banner.png";
import { getRequest, postRequest } from "../../utils/services";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useSnackbar } from "../../context/SnackbarContext";

const Feedback = () => {
  const [topic, setTopic] = useState("");
  const [feedback, setFeedback] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [feedbackType, setFeedbackType] = useState({
    id_feedback_tipo: 1,
    nome: "ideias",
  });
  const [isAnonymous, setIsAnonymous] = useState(true);
  const [setores, setSetores] = useState([""]);
  const [setorUsers, setSetorUsers] = useState([]);
  const [selectedSetor, setSelectedSetor] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [isEntireSetor, setIsEntireSetor] = useState(true);
  const [isLoadingRequest, setIsLoadingRequest] = useState(false);
  const [requestError, setRequestError] = useState({
    status: false,
    message: "",
  });

  const { user, isUnauthorizedUser, setIsUnauthorizedUser } =
    useContext(AuthContext);

  const { showSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingRequest(true);

    const payload = {
      id_setor: selectedSetor,
      id_feedback_tipo: feedbackType.id_feedback_tipo,
      assunto: topic,
      feedback,
      email: isAnonymous && feedbackType.nome !== "ideias" ? null : email,
      senha: isAnonymous && feedbackType.nome !== "ideias" ? null : password,
      id_usuario_receptor: selectedUser !== "" ? selectedUser : null,
    };

    const response = await postRequest(
      `${import.meta.env.VITE_API_BASE_URL}/feedback/criar.php`,
      payload
    );

    if (response.error) {
      setRequestError({
        status: true,
        message: response.message,
      });

      setEmail("");
      setPassword("");

      showSnackbar(response.message, "error");

      if (
        response.statusCode === 401 &&
        response.message === "Usuário não se encontra na rede Telein."
      ) {
        setIsUnauthorizedUser(true);
      }

      setTimeout(() => {
        setRequestError({
          status: false,
          message: "",
        });
      }, 3000);
      return;
    }

    showSnackbar(response.message, "success");

    setIsLoadingRequest(false);
    resetForm();
  };

  const resetForm = () => {
    setFeedback("");
    setEmail("");
    setPassword("");
    setTopic("");
    setIsAnonymous(true);
  };

  const handleFetchSectors = async () => {
    const response = await getRequest(
      `${import.meta.env.VITE_API_BASE_URL}/setores/consultarTodos.php`
    );

    if (response.error) {
      setRequestError({
        status: true,
        message: response.message,
      });

      showSnackbar(response.message, "error");

      if (response.statusCode === 401) {
        setIsUnauthorizedUser(true);
      }
      return;
    }

    setSetores(response.dados);
  };

  useEffect(() => {
    handleFetchSectors();
  }, []);

  const fetchSetorUsers = async (setorId) => {
    const response = await getRequest(
      `${
        import.meta.env.VITE_API_BASE_URL
      }/usuario/consultarPorSetor.php?id=${setorId}`
    );

    if (response.error) {
      console.error("Error fetching users:", response.error);
      setSetorUsers([]);
      return;
    }

    setSetorUsers(response.dados);
  };

  const handleSetorChange = async (event) => {
    const { value } = event.target;

    setSelectedSetor(value);

    fetchSetorUsers(value);
  };

  const handleSetIsAnonymous = (event) => {
    const { value } = event.target;

    setIsAnonymous(value === "true");
    setEmail("");
  };

  const handleFeedbackTypeChange = (type) => {
    setFeedbackType(type);
    resetForm();
  };

  const handleLoginRedirect = () => {
    navigate("login");
  };

  const handleHomeRedirect = () => {
    navigate("home");
  };

  return (
    <Box
      sx={{
        height: "90%",
        width: "600px",
        p: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{
          p: 4,
          borderRadius: 2,
          overflowX: "auto",
          maxHeight: "95%",
        }}
      >
        {isUnauthorizedUser ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img
              className="telein-banner"
              src={TeleinBanner}
              alt="Logomarca Telein"
              width="250"
              height="auto"
              style={{
                marginBottom: "30px",
              }}
            />

            <ErrorOutlineIcon
              color="error"
              sx={{
                fontSize: 60,
                mb: 2,
                color: "#d32f2f",
              }}
            />

            <Typography
              variant="h6"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                mb: 2,
                color: "#d32f2f",
                fontWeight: "bold",
              }}
            >
              Acesso restrito
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                mb: 4,
                color: "#525252",
                textAlign: "center",
              }}
            >
              Essa página é exclusiva para uso nas redes Wi-Fi da Telein!
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                mb: 2,
                color: "#525252",
                fontWeight: "bold",
              }}
            >
              Conecte-se para continuar.
            </Typography>

            <Button
              variant="outlined"
              color="info"
              startIcon={<WifiIcon />}
              sx={{
                fontFamily: "JetBrains Mono, sans-serif",
                mt: 2,
                borderWidth: "2px",
                "&:hover": {
                  borderWidth: "2px",
                },
              }}
              onClick={() => window.location.reload()}
            >
              Verificar conexão
            </Button>
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "20px",
                }}
              >
                {user ? (
                  <Button
                    type="submit"
                    variant="outlined"
                    size="medium"
                    startIcon={<AccountCircleOutlined />}
                    onClick={handleHomeRedirect}
                    sx={{
                      fontFamily: "JetBrains Mono, sans-serif",
                    }}
                  >
                    {user.nome}
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    variant="outlined"
                    size="medium"
                    startIcon={<Login />}
                    onClick={handleLoginRedirect}
                    sx={{
                      fontFamily: "JetBrains Mono, sans-serif",
                    }}
                  >
                    Login
                  </Button>
                )}
              </div>
              <img
                className="telein-banner"
                src={TeleinBanner}
                alt="Logomarca Telein"
                width="250"
                height="auto"
              />

              <Typography
                variant="h4"
                component="h1"
                sx={{
                  fontWeight: "bold",
                  WebkitBackgroundClip: "text",
                  mb: 2,
                  fontSize: "28px",
                  marginTop: "22px",
                  color: "#525252",
                  fontFamily: "JetBrains Mono, sans-serif",
                }}
              >
                Fala aí!
              </Typography>

              <Typography
                variant="subtitle1"
                color="text.secondary"
                id="subtitle"
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  margin: "-5px 0",
                }}
              >
                Sua opinião constrói nosso futuro
              </Typography>
            </div>
            <Divider sx={{ my: 3 }} />

            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid>
                <Button
                  fullWidth
                  variant={
                    feedbackType.nome === "ideias" ? "contained" : "outlined"
                  }
                  startIcon={<IdeasIcon />}
                  onClick={() =>
                    handleFeedbackTypeChange({
                      id_feedback_tipo: 1,
                      nome: "ideias",
                    })
                  }
                  sx={{
                    py: 2,
                    borderRadius: 1,
                    borderColor:
                      feedbackType.nome === "ideias" ? "#014F6D" : "grey.300",
                    fontFamily: "JetBrains Mono",
                  }}
                >
                  Ideias
                </Button>
              </Grid>

              <Grid>
                <Button
                  fullWidth
                  variant={
                    feedbackType.nome === "sugestão" ? "contained" : "outlined"
                  }
                  startIcon={<ImprovementsIcon />}
                  onClick={() =>
                    handleFeedbackTypeChange({
                      id_feedback_tipo: 2,
                      nome: "sugestão",
                    })
                  }
                  sx={{
                    py: 2,
                    borderRadius: 1,
                    fontFamily: "JetBrains Mono, sans-serif",
                    borderColor:
                      feedbackType.nome === "sugestão" ? "#014F6D" : "grey.300",
                  }}
                >
                  Sugestões/Melhorias
                </Button>
              </Grid>
              <Grid>
                <Button
                  fullWidth
                  variant={
                    feedbackType.nome === "elogios" ? "contained" : "outlined"
                  }
                  startIcon={<ComplimentIcon />}
                  onClick={() =>
                    handleFeedbackTypeChange({
                      id_feedback_tipo: 3,
                      nome: "elogios",
                    })
                  }
                  sx={{
                    py: 2,
                    borderRadius: 1,
                    borderColor:
                      feedbackType.nome === "elogios" ? "#014F6D" : "grey.300",
                    fontFamily: "JetBrains Mono",
                  }}
                >
                  Elogios
                </Button>
              </Grid>
            </Grid>

            <form onSubmit={handleSubmit} style={{ maxWidth: "480px" }}>
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Select
                  error={requestError.status}
                  labelId="sectors"
                  id="sector"
                  value={selectedSetor}
                  label="Setores"
                  displayEmpty
                  onChange={handleSetorChange}
                  sx={{
                    width: "100%",
                    fontFamily: "Montserrat, sans-serif",
                  }}
                  renderValue={(selected) => {
                    if (!selectedSetor) {
                      return (
                        <em style={{ color: "#9e9e9e" }}>Selecione um setor</em>
                      );
                    }
                    return setores.find((d) => d.id_setor === selected)?.nome;
                  }}
                >
                  <MenuItem
                    value=""
                    sx={{
                      fontFamily: "Montserrat, sans-serif",
                      color: "#9e9e9e",
                      fontStyle: "italic",
                    }}
                  >
                    <em>Selecione um setor</em>
                  </MenuItem>
                  {setores.map((setor) => (
                    <MenuItem
                      sx={{
                        fontFamily: "Montserrat, sans-serif",
                      }}
                      value={setor?.id_setor}
                    >
                      {setor?.nome}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid
                container
                spacing={2}
                sx={{ mb: 3, flexDirection: "column" }}
              >
                {selectedSetor && setorUsers.length > 0 && (
                  <>
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isEntireSetor}
                            onChange={(e) => {
                              setIsEntireSetor(e.target.checked);
                              if (e.target.checked) setSelectedUser("");
                            }}
                          />
                        }
                        label="Enviar para todos do setor"
                        sx={{ fontFamily: "Montserrat, sans-serif" }}
                      />
                    </Grid>

                    {!isEntireSetor && (
                      <Grid item xs={12}>
                        <Select
                          fullWidth
                          value={selectedUser}
                          onChange={(e) => setSelectedUser(e.target.value)}
                          displayEmpty
                          sx={{
                            fontFamily: "Montserrat, sans-serif",
                          }}
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <em style={{ color: "#9e9e9e" }}>
                                  Selecione um colaborador
                                </em>
                              );
                            }
                            return setorUsers.find(
                              (u) => u.id_usuario === selected
                            )?.nome;
                          }}
                        >
                          <MenuItem
                            value=""
                            sx={{
                              fontFamily: "Montserrat, sans-serif",
                              color: "#9e9e9e",
                              fontStyle: "italic",
                            }}
                          >
                            <em>Selecione um colaborador</em>
                          </MenuItem>
                          {setorUsers.map((user) => (
                            <MenuItem
                              key={user.id_usuario}
                              value={user.id_usuario}
                              sx={{
                                fontFamily: "Montserrat, sans-serif",
                              }}
                            >
                              {user.nome}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    )}
                  </>
                )}
              </Grid>

              <Grid container spacing={2} sx={{ mb: 3 }}>
                <TextField
                  error={requestError.status}
                  fullWidth
                  id="assunto"
                  label="Assunto"
                  variant="outlined"
                  slotProps={{
                    htmlInput: {
                      maxLength: 60,
                    },
                    inputLabel: {
                      sx: {
                        margin: "-10px, 0",
                        color: "#9e9e9e",
                        fontFamily: "Montserrat, sans-serif",
                        fontStyle: "italic",
                      },
                    },
                  }}
                  value={topic}
                  onChange={(e) => setTopic(e.target.value)}
                  required
                />
              </Grid>
              <TextField
                error={requestError.status}
                fullWidth
                multiline
                rows={4}
                label={
                  feedbackType.nome === "sugestão"
                    ? "Suas sugestões/melhorias"
                    : feedbackType.nome === "elogio"
                    ? "Seus elogios"
                    : "Suas ideias inovadoras"
                }
                variant="outlined"
                value={feedback}
                id="message"
                onChange={(e) => setFeedback(e.target.value)}
                required
                sx={{ mb: 3, fontFamily: "Montserrat, sans-serif" }}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#9e9e9e",
                      fontFamily: "Montserrat, sans-serif",
                      fontStyle: "italic",
                    },
                  },
                }}
              />

              {feedbackType.nome !== "ideias" && (
                <FormControl sx={{ mb: 3 }}>
                  <RadioGroup
                    row
                    value={isAnonymous}
                    onChange={handleSetIsAnonymous}
                  >
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="Quero me identificar"
                    />
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Enviar anonimamente"
                    />
                  </RadioGroup>
                </FormControl>
              )}

              {(feedbackType.nome === "ideias" || !isAnonymous) && (
                <>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    {feedbackType.nome === "ideias" && (
                      <Typography
                        variant="subtitle"
                        color="text.secondary"
                        id="subtitle"
                        style={{
                          fontFamily: "Montserrat, sans-serif",
                          fontStyle: "italic",
                        }}
                      >
                        É obrigatória a identificação em feedbacks de ideias.
                      </Typography>
                    )}
                    <Grid sx={{ width: "100%" }}>
                      <TextField
                        error={requestError.status}
                        fullWidth
                        label="Seu e-mail"
                        id="email"
                        variant="outlined"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required={feedbackType.nome === "ideias"}
                        slotProps={{
                          inputLabel: {
                            sx: {
                              color: "#9e9e9e",
                              fontFamily: "Montserrat, sans-serif",
                              fontStyle: "italic",
                            },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid sx={{ width: "100%", position: "relative" }}>
                      <TextField
                        error={requestError.status}
                        fullWidth
                        label="Sua senha"
                        id="senha"
                        variant="outlined"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required={feedbackType.nome === "ideias"}
                        slotProps={{
                          inputLabel: {
                            sx: {
                              color: "#9e9e9e",
                              fontFamily: "Montserrat, sans-serif",
                              fontStyle: "italic",
                            },
                          },
                        }}
                      />
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{
                          position: "absolute",
                          right: 16,
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#9e9e9e",
                        }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </Grid>
                  </Grid>
                </>
              )}

              <Button
                type="submit"
                variant="contained"
                size="large"
                endIcon={
                  isLoadingRequest ? (
                    <CircularProgress variant="indeterminate" size={25} />
                  ) : (
                    <SendIcon />
                  )
                }
                fullWidth
                disabled={
                  (feedbackType.nome === "ideias" &&
                    (!selectedSetor ||
                      !topic ||
                      !feedback ||
                      !email ||
                      !password)) ||
                  (feedbackType.nome !== "ideias" &&
                    (!selectedSetor ||
                      !topic ||
                      !feedback ||
                      (!isAnonymous && (!email || !password)))) ||
                  isLoadingRequest
                }
                sx={{
                  fontFamily: "JetBrains Mono, sans-serif",
                }}
              >
                Enviar Feedback
              </Button>
            </form>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default Feedback;
